import { render, staticRenderFns } from "./CreateBlacklist.vue?vue&type=template&id=6f9f2b18&"
import script from "./CreateBlacklist.vue?vue&type=script&lang=ts&"
export * from "./CreateBlacklist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports